<script lang="ts" setup>
  import { useApprovalStore } from '@/stores/approval.ts';
  import { MagnifyingGlassIcon } from '@heroicons/vue/20/solid';
  import { onMounted, ref } from 'vue';
  import { router } from '@/routes/router.ts';
  import dayjs from 'dayjs';
  import { loadWithStatusAndErrorHandleAsync } from '@/services/loading-svc.ts';

  const approvalStore = useApprovalStore();

  const loading = ref<boolean>(false);

  async function refreshAsync() {
    const now = dayjs(new Date());
    const startDt = dayjs(now).subtract(30, 'days').format('YYYY-MM-DD');
    const endDt = dayjs(now).add(1, 'days').format('YYYY-MM-DD');
    await loadWithStatusAndErrorHandleAsync(
      (status) => {
        loading.value = status;
      },
      async () => {
        await approvalStore.getMyConfirmApprovalApplications(startDt, endDt);
      }
    );
  }

  onMounted(async () => {
    await refreshAsync();
  });
</script>

<template>
  <DefaultLayout
    go-back
    title="완료된 신청서 목록">
    <div class="mt-0 mb-2 divider">✅</div>
    <skeleton
      v-if="loading"
      class="my-5 mb-8" />
    <table
      v-else
      class="table text-sm">
      <thead>
        <tr>
          <th>근로일자</th>
          <th>신청구분</th>
          <th>신청자</th>
          <th />
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="item in approvalStore.myConfirmApprovalApplications"
          :key="item.id">
          <td>
            <span
              v-if="!dayjs(item.date).isAfter(dayjs())"
              class="link"
              @click="
                router.push({
                  name: 'AttendanceDayView',
                  params: {
                    targetDate: dayjs(item.date).format('YYYY-MM-DD'),
                    empNo: item.empNo,
                  },
                })
              ">
              {{ dayjs(item.date).format('YYYY-MM-DD') }}
            </span>
            <span v-else>
              {{ dayjs(item.date).format('YYYY-MM-DD') }}
            </span>
          </td>
          <td>{{ item.approvalDocument?.name }}</td>
          <td>{{ item.employee?.name }}</td>
          <td>
            <button
              class="btn btn-sm btn-secondary btn-circle"
              @click="
                router.push({
                  name: 'ApprovalConfirmDetail',
                  params: { id: item.id },
                })
              ">
              <MagnifyingGlassIcon class="w-4 h-4" />
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </DefaultLayout>
</template>
